'use client'

import { CANARY_MISSION } from '@/enum/enum'
import Link from 'next/link'

export const Donate = () => {
  const donationAmounts = [18, 36, 100, 250, 500]

  const getDonationHref = (amount?: number) =>
    amount ? `/donate?amount=${amount}` : '/donate'

  return (
    <div className="w-full bg-gradient-to-r from-[#010231] to-black p-9 flex justify-center">
      <div className="flex items-center lg:gap-[130px] gap-4 md:flex-row flex-col w-[90vw] justify-center">
        {/* Title */}
        <div>
          <h1 className="text-white text-center sm:text-[45px] text-[42px] font-semibold sm:leading-[55px] leading-[48px] uppercase mb-2 [word-spacing:16px]">
            help us fight
            <br />
            <span className="sm:text-[50px] text-[45px] font-black">antisemitism</span>
          </h1>
          <p className="text-white text-center text-sm font-semibold">
            Donate to {CANARY_MISSION.NAME}
          </p>
        </div>

        <div className="flex flex-col items-center justify-center">
          <div className="mt-6 grid grid-cols-3 gap-5">
            {donationAmounts.map((amount) => (
              <Link
                key={amount}
                href={getDonationHref(amount)}
                prefetch={false}
                className="w-24 h-10 border border-white bg-white/10 hover:bg-white/20 !text-white font-semibold rounded-lg transition-colors flex items-center justify-center"
              >
                ${amount}
              </Link>
            ))}
            <Link
              href={getDonationHref()}
              prefetch={false}
              className="w-24 h-10 border border-white bg-white/10 hover:bg-white/20 !text-white font-semibold rounded-lg transition-colors flex items-center justify-center"            >
              OTHER
            </Link>
          </div>
          <Link
            href={getDonationHref()}
            prefetch={false}
            className="mt-6 w-full h-[30px] bg-feYellow text-black font-bold rounded-lg hover:bg-black hover:text-feYellow hover:border-[3px] hover:border-feYellow transition-colors flex items-center justify-center"

          >
            DONATE
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Donate